import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';

const Slippage = ({ slippage, setSlippage }: any) => {
  const onBlur = (value: string | number, on_change: Function) => {
    const val = Number(String(value).replace(',', '.'));
    if (val) {
      on_change(val);
    } else {
      on_change(0);
    }
  };

  return (
    <>
      <div className='row slippage'>
        <Text size={12}>Slippage</Text>
      </div>
      <div className='row slippage__buttons'>
        <div className='button_wrapper'>
          <Button
            text='0.1%'
            size='s'
            action={() => {
              setSlippage(0.1);
            }}
            variant='swap_settings'
            is_active={slippage == '0.1'}
          ></Button>
        </div>
        <div className='button_wrapper'>
          <Button
            text='0.5%'
            size='s'
            action={() => {
              setSlippage(0.5);
            }}
            variant='swap_settings'
            is_active={slippage == '0.5'}
          ></Button>
        </div>
        <div className='button_wrapper'>
          <Button
            text='1%'
            size='s'
            action={() => {
              setSlippage(1);
            }}
            variant='swap_settings'
            is_active={slippage == '1'}
          ></Button>
        </div>
        <div className='button_wrapper'>
          <Button
            text='3%'
            size='s'
            action={() => {
              setSlippage(3);
            }}
            variant='swap_settings'
            is_active={slippage == '3'}
          ></Button>
        </div>
        <div className='button_wrapper'>
          <input
            type='number'
            className='input btn--swap_settings  text--12'
            value={slippage}
            onChange={(e) => setSlippage(e.target.value)}
            onBlur={() => onBlur(slippage, setSlippage)}
          />
        </div>
      </div>
    </>
  );
};

export default Slippage;
